import { styled } from '@mui/material';
import { theme, up, lightPalette } from '../../../../theme';

export const classes = {
  root: 'root',
  containerMainGrid: 'containerMainGrid',
  CardTitle: 'CardTitle',
  rightGridForBothStep: 'rightGridForBothStep',
  rightGridMainBoxForBothStep: 'rightGridMainBoxForBothStep',
  registerTypo: 'registerTypo',
  logoBox: 'logoBox',
  welcomeHeader: 'welcomeHeader',
  CardHeader: 'CardHeader',
  CardContent: 'CardContent',
  rightBoxInfoSubtitleStepOne: 'rightBoxInfoSubtitleStepOne',
  formAllTextFieldStepOne: 'formAllTextFieldStepOne',
  continueButtonStepOne: 'continueButtonStepOne',
  termOfServiceBackdrop: 'termOfServiceBackdrop',
  formCommonTextfieldStepTwo: 'formCommonTextfieldStepTwo',
  eyeIconForPassword: 'eyeIconForPassword',
  formSelectionDropdownStepTwo: 'formSelectionDropdownStepTwo',
  termsOfServiceAndPrivacyPolicyBox: 'termsOfServiceAndPrivacyPolicyBox',
  createAccountButtonStepTwo: 'createAccountButtonStepTwo',
  stepperBox: 'stepperBox',
  formControl: 'formControl',
  submitButton: 'submitButton',
  checkBox: 'checkBox',
  loginLink: 'loginLink',
  firstStepper: 'firstStepper',
  lastStepper: 'lastStepper',
  termsOfServiceLink: 'termsOfServiceLink',
  popup: 'popup',
  overlay: 'overlay',
  closeAction: 'closeAction',
  CancelButton: 'CancelButton',
  Box: 'Box',
  AcceptButton: 'AcceptButton',
};

export const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {},

  [`& .${classes.containerMainGrid}`]: {
    height: '100vh',
    background: 'rgba(255, 255, 255, 1)',
  },

  [`& .${classes.CardTitle}`]: {
    color: theme.palette.darkPurple.main,
  },

  [`& .${classes.termsOfServiceLink}`]: {
    color: lightPalette.primary.main,
    fontWeight: '500',
    textDecoration: 'none',
  },
  [`& .${classes.lastStepper}`]: {
    marginLeft: '2px',
    width: '27px',
    height: '9px',
    borderRadius: '5px',
  },
  [`& .${classes.loginLink}`]: {
    fontWeight: '500',
    textDecoration: 'none',
    color: lightPalette.primary.main,
  },
  [`& .${classes.firstStepper}`]: {
    marginRight: '2px',
    paddingLeft: '0px',
    width: '9px',
    height: '9px',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  [`& .${classes.Box}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [up('xs')]: {
      height: '45px',
    },
    [up('sm')]: {
      height: '70px',
    },
    [up('md')]: {
      height: '75px',
    },
    [up('lg')]: {
      height: '67px',
    },
    [up('xl')]: {
      height: '92px',
    },
    [up('xxl')]: {
      height: '100px',
    },
  },
  [`& .${classes.AcceptButton}`]: {
    backgroundColor: lightPalette.primary.main,
    color: lightPalette.secondaryWhite.main,
    marginTop: 0,
    [up('xs')]: {
      width: '80px',
      height: '30px',
      margin: '3px',
    },
    [up('sm')]: {
      width: '99px',
      height: '40px',
      margin: '4px',
    },
    [up('md')]: {
      width: '110px',
      height: '40px',
      margin: '6px',
    },
    [up('lg')]: {
      width: '110px',
      height: '44px',
      margin: '7px',
    },
    [up('xl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
    [up('xxl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
  },
  [`& .${classes.CancelButton}`]: {
    backgroundColor: lightPalette.paperWhite.main,
    color: lightPalette.lunarBase.main,
    marginTop: 0,
    [up('xs')]: {
      width: '80px',
      height: '30px',
      margin: '3px',
    },
    [up('sm')]: {
      width: '99px',
      height: '40px',
      margin: '4px',
    },
    [up('md')]: {
      width: '110px',
      height: '40px',
      margin: '6px',
    },
    [up('lg')]: {
      width: '110px',
      height: '44px',
      margin: '7px',
    },
    [up('xl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
    [up('xxl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
  },
  [`& .${classes.rightGridForBothStep}`]: {
    padding: '25px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  [`& .${classes.rightGridMainBoxForBothStep}`]: {
    [up('xs')]: {
      width: '60vw',
    },
    [up('sm')]: {
      width: '30vw',
    },
    [up('md')]: {
      width: '26vw',
    },
  },

  [`& .${classes.logoBox}`]: {
    marginBottom: theme.spacing(1),
    [up('xs')]: {
      width: '90px',
    },
    [up('sm')]: {
      width: '60px',
    },
    [up('md')]: {
      width: '90px',
    },
    [up('lg')]: {
      width: '120px',
    },
    [up('xl')]: {
      width: '144px',
    },
    [up('xxl')]: {
      width: '171px',
    },
  },

  [`& .${classes.welcomeHeader}`]: {
    marginBottom: '0.5vh',
  },

  [`& .${classes.CardHeader}`]: {
    width: '100%',
    position: 'sticky',
    color: lightPalette.darkPurple.main,
    background: lightPalette.japanBlush.main,
    [up('xs')]: {
      height: '40px',
    },
    [up('sm')]: {
      height: '60px',
    },
    [up('md')]: {
      height: '60px',
    },
    [up('lg')]: {
      height: '60px',
    },
    [up('xl')]: {
      height: '80px',
    },
    [up('xxl')]: {
      height: '90px',
    },
  },

  [`& .${classes.CardContent}`]: {
    overflow: 'auto',
    width: '100%',
    [up('sm')]: {
      height: '390px',
    },
    [theme.breakpoints.up('md')]: {
      height: '390px',
    },
    [theme.breakpoints.up('lg')]: {
      height: '440px',
    },
    [theme.breakpoints.up('xl')]: {
      height: '520px',
    },
    [theme.breakpoints.up('xxl')]: {
      height: '650px',
    },
    borderRadius: '5px',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
  },

  [`& .${classes.termOfServiceBackdrop}`]: {
    color: theme.palette.secondaryWhite.main,
    zIndex: theme.zIndex.drawer + 1,
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
  },
  [`& .${classes.closeAction}`]: {
    cursor: 'pointer',
    width: '20%',
    height: '100%',
  },
  [`& .${classes.popup}`]: {
    display: 'flex',
    top: '50%',
    left: '50%',
    borderRadius: '5px',
    backgroundColor: 'white',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    zIndex: 1000,
    [up('sm')]: {
      width: '400px',
      height: '450px',
      maxWidth: '600px',
    },
    [up('md')]: {
      width: '500px',
      height: '450px',
      maxWidth: '800px',
    },
    [up('lg')]: {
      width: '600px',
      height: '500px',
      maxWidth: '900px',
    },
    [up('xl')]: {
      width: '700px',
      height: '600px',
      maxWidth: '800px',
    },
    [up('xxl')]: {
      width: '800px',
      height: '740px',
      maxWidth: '1000px',
    },
  },
  [`& .${classes.overlay}`]: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 999,
  },

  [`& .${classes.rightBoxInfoSubtitleStepOne}`]: {
    [up('xs')]: {
      marginBottom: '6px',
    },
    [up('sm')]: {
      marginBottom: '10px',
    },
    [up('md')]: {
      marginBottom: '12px',
    },
    [up('lg')]: {
      marginBottom: '14px',
    },
    [up('xl')]: {
      marginBottom: '24px',
    },
    [up('xxl')]: {
      marginBottom: '30px',
    },
  },

  [`& .${classes.formAllTextFieldStepOne}`]: {
    [up('xs')]: {
      marginBottom: '6px',
    },
    [up('sm')]: {
      marginBottom: '8px',
    },
    [up('md')]: {
      marginBottom: '12px',
    },
    [up('lg')]: {
      marginBottom: '16px',
    },
    [up('xl')]: {
      marginBottom: '20px',
    },
    [up('xxl')]: {
      marginBottom: '26px',
    },
  },

  [`& .${classes.continueButtonStepOne}`]: {
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.darker,
    },
    [up('xs')]: {
      height: '30px',
      marginBottom: '6px',
    },
    [up('sm')]: {
      height: '30px',
      marginBottom: '8px',
    },
    [up('md')]: {
      height: '36px',
      marginBottom: '10px',
    },
    [up('lg')]: {
      height: '44px',
      marginBottom: '14px',
    },
    [up('xl')]: {
      height: '52px',
      marginBottom: '20px',
    },
    [up('xxl')]: {
      height: '56px',
      marginBottom: '26px',
    },
  },

  [`& .${classes.formCommonTextfieldStepTwo}`]: {
    [up('xs')]: {
      marginBottom: '6px',
    },
    [up('sm')]: {
      marginBottom: '8px',
    },
    [up('md')]: {
      marginBottom: '12px',
    },
    [up('lg')]: {
      marginBottom: '16px',
    },
    [up('xl')]: {
      marginBottom: '20px',
    },
    [up('xxl')]: {
      marginBottom: '26px',
    },
  },

  [`& .${classes.eyeIconForPassword}`]: {
    filter: 'brightness(98%) contrast(60%) sepia(10%)',
    [up('xs')]: {
      height: '10px',
      width: '10px',
    },
    [up('sm')]: {
      height: '10px',
      width: '10px',
    },
    [up('md')]: {
      height: '12px',
      width: '12px',
    },
    [up('lg')]: {
      height: '14px',
      width: '14px',
    },
    [up('xl')]: {
      height: '16px',
      width: '16px',
    },
    [up('xxl')]: {
      height: '18px',
      width: '18px',
    },
  },

  [`& .${classes.formSelectionDropdownStepTwo}`]: {
    [up('xs')]: {
      marginBottom: '6px',
    },
    [up('sm')]: {
      marginBottom: '8px',
    },
    [up('md')]: {
      marginBottom: '10px',
    },
    [up('lg')]: {
      marginBottom: '12px',
    },
    [up('xl')]: {
      marginBottom: '14px',
    },
    [up('xxl')]: {
      marginBottom: '18px',
    },
  },

  [`& .${classes.termsOfServiceAndPrivacyPolicyBox}`]: {
    alignItems: 'center',
    [up('xs')]: {
      marginBottom: '8px',
    },
    [up('sm')]: {
      marginBottom: '10px',
    },
    [up('md')]: {
      marginBottom: '16px',
    },
    [up('lg')]: {
      marginBottom: '24px',
    },
    [up('xl')]: {
      marginBottom: '28px',
    },
    [up('xxl')]: {
      marginBottom: '40px',
    },
  },

  [`& .${classes.createAccountButtonStepTwo}`]: {
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.darker,
    },
    [up('xs')]: {
      height: '30px',
      marginBottom: '6px',
    },
    [up('sm')]: {
      height: '30px',
      marginBottom: '8px',
    },
    [up('md')]: {
      height: '36px',
      marginBottom: '10px',
    },
    [up('lg')]: {
      height: '44px',
      marginBottom: '14px',
    },
    [up('xl')]: {
      height: '52px',
      marginBottom: '20px',
    },
    [up('xxl')]: {
      height: '56px',
      marginBottom: '26px',
    },
  },

  [`& .${classes.stepperBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    [up('xs')]: {
      marginTop: '8px',
    },
    [up('sm')]: {
      marginTop: '12px',
    },
    [up('md')]: {
      marginTop: '18px',
    },
    [up('lg')]: {
      marginTop: '24px',
    },
    [up('xl')]: {
      marginTop: '30px',
    },
    [up('xxl')]: {
      marginTop: '40px',
    },
  },
  [`& .${classes.formControl}`]: {
    width: '100%',
  },
  [`& .${classes.submitButton}`]: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  [`& .${classes.registerTypo}`]: {
    fontWeight: '400',
    textAlign: 'center',
    color: theme.palette.shoeWax.semiLight,
  },
  [`& .${classes.checkBox}`]: {
    '&.Mui-checked': {
      '&, & + .MuiFormControlLabel-label': {
        color: theme.palette.primary.main,
      },
    },
  },
  [`& .${classes.checkBox}`]: {
    '&.Mui-checked': {
      '&, & + .MuiFormControlLabel-label': {
        color: theme.palette.primary.main,
      },
    },
  },
}));
